import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';
import { ArrowIcon } from '@/icons';

export const StyledTitleWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;

  &&& svg {
    transform: scale(0.75);
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    &&& svg {
      transform: scale(1);
    }
  }
`;

export const StyledTitle = styled.div`
  text-transform: uppercase;
  ${pickThemeFontStyles('12', '12', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};
  text-align: left;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('16', '16', 'NORMAL')};
  }
`;

export const StyledSubTitle = styled.div`
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  color: ${COLORS.CHARCOAL};
  margin-bottom: 0.25rem;
`;

export const StyledDataList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const StyledDataListItem = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledLabel = styled.div`
  ${pickThemeFontStyles('16', '24', 'NORMAL')};
  color: ${COLORS.CHARCOAL};
`;

export const StyledValue = styled.div`
  ${pickThemeFontStyles('24', '24', 'BOLD')};
  color: ${COLORS.BLACK_PRIMARY};
`;

export const StyledTrendsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const StyledHideTrendsList = styled.div<{
  $isVisible: boolean;
  $itemsCount: number;
}>`
  max-height: ${({ $isVisible, $itemsCount }) => ($isVisible ? `${$itemsCount * 2.5}rem` : 0)};
  transition: max-height 0.4s ease-out;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: ${({ $isVisible }) => ($isVisible ? '1rem' : 0)};
`;

export const StyledCategoryItem = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledCategoryItemRightWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 0.125rem;
`;

export const StyledCategoryItemName = styled.div`
  ${pickThemeFontStyles('16', '24', 'NORMAL')};
  color: ${COLORS.CHARCOAL};
`;

export const StyledCategoryItemPercent = styled.div`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};
`;

export const StyledArrowIcon = styled(ArrowIcon)<{ $isVisible: boolean }>`
  transform: ${({ $isVisible }) => ($isVisible ? 'rotate(-90deg)' : 'rotate(90deg)')};
`;
